module.exports = __webpack_public_path__ + "assets/dienst2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/dienst2.jpg
// module id = 358
// module chunks = 0